
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./calendar-module.cjs.production.min.js')
} else {
  module.exports = require('./calendar-module.cjs.development.js')
}
